<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Notas de Serviço</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Notas de serviço</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Número da nota</th>
                    <th scope="col" class="border-0">Número RPS</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0">Data de emissão</th>
                    <th scope="col" class="border-0">Período</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(noteExtract, index) in noteExtracts" :key="index">
                    <td></td>
                    <td>{{ noteExtract.NFSeNumber }}</td>
                    <td>{{ noteExtract.RPSNumber }}</td>
                    <td>{{ noteExtract.Amount | currency }}</td>
                    <td>{{ noteExtract.EmissionDate | date }}</td>
                    <td>{{ noteExtract.Period | monthYear }}</td>
                    <td>
                      <span
                        :class="[
                          GetSpanClass(
                            noteExtract.NoteExtractPartnerStatus.Code
                          ),
                        ]"
                        >{{ noteExtract.NoteExtractPartnerStatus.Name }}</span
                      >
                    </td>
                    <td>
                      <div class="dropdown tabledropdwn">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetNoteExtract(noteExtract.Id, true, false)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingModal ? 'disabled' : ''"
                            v-on:click.stop="
                              GetNoteExtract(noteExtract.Id, true, true)
                            "
                          >
                            <template v-if="loadingModal">
                              <loader
                                :small="true"
                                :isLoading="loadingModal"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="RemoveNoteExtractValidate(index)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      noteExtracts == null ||
                      noteExtracts == undefined ||
                      noteExtracts.length == 0
                    "
                  >
                    <td colspan="8">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormNoteExtractType"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <div>
        <div>
          <d-form-row>
            <d-col md="12" class="form-group">
              <d-select v-model="noteExtractType" :value="null">
                <option :value="null" selected>Tipo de arquivo</option>
                <option :value="1">XML</option>
                <option :value="2">PDF</option>
                <option :value="3">TXT</option>
              </d-select>
            </d-col>
          </d-form-row>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="AddNoteExtractType()">
          Adicionar
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="mFormNoteExtractXml"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div>
          <ValidationObserver ref="formValidation">
            <!-- Period -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Período</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-bind:inputClass="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.Period"
                    format="MMMM yyyy"
                    minimumView="month"
                    :disabled="isSeeing"
                  ></date-field>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- NFSeUrl -->
            <d-form-row v-if="isCreating">
              <d-col md="12" class="form-group">
                <label>Arquivo XML</label>
                <b-form-file
                  type="file"
                  placeholder="Selecione ou arraste um arquivo"
                  drop-placeholder="Solte o arquivo aqui"
                  browse-text="Selecionar"
                  accept="text/xml"
                  @change="SelectNoteExtractFile($event, true)"
                  @input="SelectNoteExtractFile($event, false)"
                />
              </d-col>
            </d-form-row>
            <d-form-row v-if="isSeeing">
              <!-- NFSeNumber -->
              <d-col md="6" class="form-group">
                <label>Número da nota</label>
                <d-form-input
                  type="text"
                  v-model="infoNoteExtract.NFSeNumber"
                  :disabled="true"
                />
              </d-col>
              <!-- RPSNumber -->
              <d-col md="6" class="form-group">
                <label>Número RPS</label>
                <d-form-input
                  type="text"
                  v-model="infoNoteExtract.RPSNumber"
                  :disabled="true"
                />
              </d-col>
            </d-form-row>
            <d-form-row v-if="isSeeing">
              <!-- Amount -->
              <d-col md="6" class="form-group">
                <label>Valor</label>
                <currency-input
                  class="form-control"
                  v-model="infoNoteExtract.Amount"
                  :disabled="true"
                />
              </d-col>
              <!-- EmissionDate -->
              <d-col md="6" class="form-group">
                <label>Data de emissão</label>
                <date-field
                  v-model="infoNoteExtract.EmissionDate"
                  :disabled="true"
                />
              </d-col>
            </d-form-row>
          </ValidationObserver>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddNoteExtractValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFormNoteExtractFile"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div>
          <ValidationObserver ref="formValidation">
            <d-form-row>
              <!-- Period -->
              <d-col md="12" class="form-group">
                <label>Período</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-bind:inputClass="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.Period"
                    format="MMMM yyyy"
                    minimumView="month"
                    :disabled="isSeeing"
                  ></date-field>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- NFSeNumber -->
              <d-col md="6" class="form-group">
                <label>Número da nota</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    type="text"
                    v-model="infoNoteExtract.NFSeNumber"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- RPSNumber -->
              <d-col md="6" class="form-group">
                <label>Número RPS</label>
                <d-form-input
                  type="text"
                  v-model="infoNoteExtract.RPSNumber"
                  :disabled="isSeeing"
                />
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- Amount -->
              <d-col md="6" class="form-group">
                <label>Valor</label>
                <ValidationProvider
                  rules="required|min_value:0.01"
                  v-slot="{ errors, invalid }"
                >
                  <currency-input
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    class="form-control"
                    v-model="infoNoteExtract.Amount"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- EmissionDate -->
              <d-col md="6" class="form-group">
                <label>Data de emissão</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-bind:inputClass="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.EmissionDate"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- NFSeUrl -->
            <d-form-row v-if="isCreating">
              <d-col md="12" class="form-group">
                <label>Arquivo</label>
                <b-form-file
                  type="file"
                  placeholder="Selecione ou arraste um arquivo"
                  drop-placeholder="Solte o arquivo aqui"
                  browse-text="Selecionar"
                  accept="application/pdf, text/plain"
                  @change="SelectNoteExtractFile($event, true)"
                  @input="SelectNoteExtractFile($event, false)"
                />
              </d-col>
            </d-form-row>
          </ValidationObserver>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddNoteExtractValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <date-field
            v-model="filter.Period"
            format="MMMM yyyy"
            minimumView="month"
          ></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova nota"
      v-on:click="OpenNoteExtractType()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "note-extracts",
  data: function () {
    return {
      countFilter: 0,
      noteExtractType: null,
      filter: {
        Period: null,
      },
      validatedFormValidation: false,
      loadingList: false,
      loadingModal: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      noteExtracts: [],
      infoNoteExtract: {
        RPSNumber: null,
        NFSeNumber: null,
        Amount: null,
        EmissionDate: null,
        Period: null,
        NFSeUrl: null,
      },
      noteExtractFile: null,
      isSeeing: false,
      isCreating: false,
      modalTitle: "Nova nota",
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListNoteExtract();
    },
    "pagination.RowsPerPage": function () {
      this.ListNoteExtract();
    },
  },
  mounted() {
    if (this.$route.query["add-note"] == "true") this.OpenNoteExtractType();

    this.ListNoteExtract();
  },
  methods: {
    SelectNoteExtractFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (this.noteExtractType == "1") {
        FileToBase64(file)
          .then((response) => {
            if (response.startsWith("data:text/xml")) {
              this.noteExtractFile = file;
            } else {
              this.$makeToast(
                "O arquivo selecionado não é um XML válido",
                "danger",
                "Nota de serviço"
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        if (file.type == "application/pdf" || file.type == "text/plain") {
          this.noteExtractFile = file;
        } else {
          this.$makeToast(
            "O arquivo selecionado não é um PDF ou TXT válido",
            "danger",
            "Nota de serviço"
          );
        }
      }
    },
    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListNoteExtract();
    },
    ResetFilter: function () {
      this.filter = {
        Period: null,
      };
      this.ListNoteExtract();
    },
    ListNoteExtract: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Period)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Period": this.filter.Period,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListNoteExtractPartner", { params: data })
        .then((response) => {
          this.noteExtracts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível listar as notas",
            "danger",
            "Notas de serviço",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetNoteExtract: function (id, seeing, download) {
      this.loadingModal = true;
      if (!download) {
        this.isCreating = false;
        this.ResetInfoNoteExtract();
        this.OpenMNoteExtract();
      }

      this.$store
        .dispatch("GetNoteExtractPartner", { id: id })
        .then(
          (response) => {
            this.infoNoteExtract = response;

            if (!download && typeof seeing != "undefined") {
              this.isSeeing = true;
              this.modalTitle = "Detalhes da nota";
            }

            if (download && hasValue(response.NFSeUrl)) {
              this.$makeToast(
                "Aguarde a conclusão do download",
                "info",
                "Nota de serviço"
              );
              window.open(response.NFSeUrl, "_self");
            }
          },
          (error) => {
            this.$makeToast(
              "Não foi possível buscar as informações da nota",
              "danger",
              "Notas de serviço",
              error
            );
          }
        )
        .finally(() => {
          this.loadingModal = false;
          if (download) {
            setTimeout(() => {
              $(".tabledropdwn > .dropdown-menu.show").removeClass("show");
              this.loadingReport = false;
            }, 250);
          }
        });
    },
    RemoveNoteExtractValidate(index) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover a nota de serviço?",
        "Confirmar",
        this.RemoveNoteExtract,
        index
      );
    },
    RemoveNoteExtract: function (i) {
      let deleted = this.noteExtracts[i];
      let self = this;

      this.$store.dispatch("DeleteNoteExtractPartner", { id: deleted.Id }).then(
        (res) => {
          self.$showToast(
            "Nota de serviço",
            `A nota de serviço foi removida da sua lista`,
            "success"
          );
          self.FeedbackModal();
        },
        (err) => {
          self.$showToastResponseAPI(
            "Nota de serviço",
            "Não foi possível remover a nota de serviço",
            undefined,
            err
          );
        }
      );
    },
    AddNoteExtractType: function () {
      this.$bvModal.hide("mFormNoteExtractType");
      this.OpenMNewNoteExtract();
      if (this.noteExtractType == "1") {
        this.OpenMNoteExtract();
      } else {
        this.OpenMNoteExtractFile();
      }
    },
    OpenNoteExtractType: function () {
      this.noteExtractType = null;
      this.modalTitle = "Nova nota";
      this.$bvModal.show("mFormNoteExtractType");
    },
    OpenMNoteExtract: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormNoteExtractXml");
    },
    OpenMNoteExtractFile: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormNoteExtractFile");
    },
    OpenMNewNoteExtract: function () {
      this.ResetInfoNoteExtract();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Nova nota";
    },
    ResetInfoNoteExtract: function () {
      this.infoNoteExtract = {
        RPSNumber: null,
        Amount: null,
        EmissionDate: null,
        Period: null,
        NFSeUrl: null,
      };
    },
    AddNoteExtractValidated: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          if (
            this.noteExtractFile != null &&
            this.noteExtractFile != undefined
          ) {
            this.AddNoteExtract();
          } else {
            this.$makeToast(
              "Selecione um arquivo XML",
              "danger",
              "Nota de serviço"
            );
          }
        }
      });
    },
    AddNoteExtract() {
      if (this.isCreating) {
        this.loadingModal = true;
        let noteExtract = JSON.parse(JSON.stringify(this.infoNoteExtract));
        delete noteExtract.NFSeUrl;
        var formData = this.GetFormData(noteExtract);
        formData.append(
          "File",
          this.noteExtractFile,
          this.noteExtractFile.name
        );
        this.$store
          .dispatch("AddNoteExtractPartner", formData)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar a nota",
              "success",
              "Notas de serviço"
            );
            this.FeedbackModal();
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível adicionar a nota",
              "danger",
              "Notas de serviço",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    FeedbackModal() {
      this.ListNoteExtract();
      if (this.noteExtractType == "1") {
        this.$bvModal.hide("mFormNoteExtractXml");
      } else {
        this.$bvModal.hide("mFormNoteExtractFile");
      }
    },
    GetSpanClass: function (codeNoteExtractPartnerStatus) {
      let variation = "badge badge-warning";
      if (codeNoteExtractPartnerStatus == "2") {
        variation = "badge badge-success";
      } else if (codeNoteExtractPartnerStatus == "3") {
        variation = "badge badge-danger";
      }
      return variation;
    },
  },
};
</script>

<style>
.custom-file-input:focus ~ .custom-file-label::after {
  color: black;
  background: #e5e7ec;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/noteExtracts.vue